<template>
    <router-view/>
    <Teleport to="#sectionInfoByRoute">
        <router-view name="sectionInfoByRoute" v-on:close-dialog="onCloseSectionInfoByRoute"/>
    </Teleport>
</template>

<script>

export default {
    name: "EmptyRouteComponent",
    methods: {
        onCloseSectionInfoByRoute(){
            this.setRoute.returnToParent(this.$route, this.$router)
        },
    }
}
</script>

<style scoped>

</style>